import type { TFunction } from "i18next";
import {
  AccordionProps,
  LINE_BREAK,
} from "../../components/shared/Accordion/Accordions";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import CarrierVideoEmbed from "../../components/shared/Video/CarrierVideoEmbed";
import { HelpFAQAnswerWrapper } from "./Help.styles";

const paragraph = (content: string) =>
  GetTypographyContent({
    content,
    size: "medium",
  });

export const carrierHelpAccordions = (
  reqID: string,
  t: TFunction<"translation">,
): AccordionProps[] => [
  {
    title: t("help.carrier.testFor.title"),
    content: (
      <HelpFAQAnswerWrapper>
        <div style={{ display: "grid" }}>
          <CarrierVideoEmbed
            type="carrier"
            reqID={reqID}
            videoLocation="carrier_learn_more"
          />
        </div>
        {LINE_BREAK}
        {LINE_BREAK}
        {paragraph(t("help.carrier.testFor.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "carrierTestFor",
  },
  {
    title: t("help.carrier.resultTypes.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.carrier.resultTypes.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "carrierScreenResults",
  },
  {
    title: t("help.carrier.familyHistory.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.carrier.familyHistory.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "carrierFamilyHistory",
  },
  {
    title: t("help.carrier.eligibility.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.carrier.eligibility.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "carrierScreenEligible",
  },
  {
    title: t("help.carrier.timing.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.carrier.timing.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "carrierResultTime",
  },
];
